var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-btn',{attrs:{"color":"primary","label":"Export","push":"","size":"sm"},on:{"click":_vm.export2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }